import aside from './aside.vue';
export default aside;
